<template>
  <div class="icon-burger">
    <i />
    <i />
    <i />
  </div>
</template>

<style scoped>
.icon-burger {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 24px;
  height: auto;
  &:hover {
    opacity: 0.7;
  }

  i {
    width: 24px;
    height: 3px;
    background-color: rgb(var(--v-theme-ui-white));
    border-radius: 2px;
  }
}
</style>
